import IHocContext from '@@types/IHocContext';

import SpinnerBig from '~/components/common/Spinner/Big';
import hoc from '~/components/hoc';
import { Page } from '~/constants';
import cond from 'ramda/es/cond';
import equals from 'ramda/es/equals';
import T from 'ramda/es/T';
import * as React from 'react';

const Messenger = React.lazy(() => import('./Messenger'));

const PopupChannel = React.lazy(() => import('./PopupChannel'));

const Integration = React.lazy(() => import('./Integration'));

const PopupImage = React.lazy(() => import('./PopupImage'));

const SelectShareTenant = React.lazy(() => import('./SelectShareTenant'));

const Orgs = React.lazy(() => import('./Orgs'));

const Error400 = React.lazy(() => import('./Error400'));

const Error500 = React.lazy(() => import('./Error500'));

const Unauthorized = React.lazy(() => import('./Unauthorized'));

const NotFound = React.lazy(() => import('./NotFound'));

const Pages: React.FC<IHocContext> = ({ uiState }) => {
  return (
    <React.Suspense fallback={<SpinnerBig bg="transparent" />}>
      {cond([
        [equals(Page.Messenger), () => <Messenger />],
        [equals(Page.PopupChannel), () => <PopupChannel />],
        [equals(Page.Integration), () => <Integration />],
        [equals(Page.PopupImage), () => <PopupImage />],
        [equals(Page.ShareChannel), () => <SelectShareTenant />],
        [equals(Page.Orgs), () => <Orgs />],
        [equals(Page.Error400), () => <Error400 />],
        [equals(Page.Error500), () => <Error500 />],
        [equals(Page.Unauthorized), () => <Unauthorized />],
        [equals(Page.UnauthorizedIP), () => <Unauthorized />],
        [T, () => <NotFound />],
      ])(uiState.currentPage)}
    </React.Suspense>
  );
};

export default hoc(Pages);
